import { render, staticRenderFns } from "./CreateLayoutContent.vue?vue&type=template&id=42164d96&scoped=true"
import script from "./CreateLayoutContent.vue?vue&type=script&lang=js"
export * from "./CreateLayoutContent.vue?vue&type=script&lang=js"
import style0 from "./CreateLayoutContent.vue?vue&type=style&index=0&id=42164d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42164d96",
  null
  
)

export default component.exports